import * as React from "react";
import { useState } from "react";
import { ISerializedUIField, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import WDFilterPanel from "../../../common/components/WDFilterPanel";
import { FieldContainer } from "../../../common/FieldContainer";
import { DataSourceProperty } from "../../../common/ui-props/DataSourceProperty";
import { createDefaultPropsForWidgetWrapperWithSidebar, WidgetWrapperWithSidebar } from "../../../common/widget-wrappers/WidgetWrapperWithSidebar";
import './empty-widget.scss'
import { convertColor, extractContextData, loadInitialData } from "../../../../util";
import { useEffectWithPolling } from "uxp/components";
import {
    executeAndBind,
} from "../../../common/data-source-picker/datasource";
import { useInitialContextData } from "../../../../hooks/useContextData";

const XPR: React.FunctionComponent<IWidgetTemplateProps> = (props) => {

    let uiProps = props?.uiProps || {};

    const [widgetData, setWidgetData] = React.useState<any>({})
    const [loading, setLoading] = useState(false);
    const [contextData, setContextData] = useState<{ [key: string]: any }>({})
    const [disableDrop, setDisableDrop] = useState(false)

    const containerRef = React.useRef(null)

    const XPRProps = createDefaultPropsForWidgetWrapperWithSidebar({
        'initialDataSource': DataSourceProperty('Initial Data Source', uiProps.source, uiProps.datasources, props.uxpContext, props.designer, 'dictionary-array'),
    });

    const { isLoading, initialContextData } = useInitialContextData(props, [props?.uiProps?.initialDataSource])

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    React.useEffect(() => {
        console.log('context_data_________', contextData)
    }, [contextData])

    // TODO: check and remove this , not being used it seems 
    useEffectWithPolling(props.uxpContext, "emptyWidget", 60000, async () => {
        if (props.designer?.mode == 'preview' || props.designer?.mode == 'thumbnail')
            return;

        executeAndBind(props.uxpContext, uiProps.initialDataSource, uiProps.datasources, {})
            .then(d => {
                setWidgetData({
                    [uiProps.initialDataSource?.source]: d
                })
            })
    }, [props.designer]);

    React.useEffect(() => {
        console.log("disableDrop", disableDrop)
    }, [disableDrop])

    React.useEffect(() => {
        updateHeight()
    }, [uiProps]);

    function updateHeight() {
        const container = containerRef.current as HTMLDivElement
        if (container) {
            if (props.updateWidgetHeight) {
                props.updateWidgetHeight(container.scrollHeight)
            }
        }
    }

    let background = uiProps.chartContainer?.background;
    let backgroundColor: string = undefined;
    if (background?.color) {
        backgroundColor = convertColor(background.color, contextData);
    }
    return (<WidgetWrapperWithSidebar
        containerRef={containerRef}
        designer={props.designer}
        contextData={contextData}
        propDef={XPRProps}
        uiProps={uiProps}
        className="uxp-empty-widget-template"
        filterSection={() => (props.designer?.mode == 'preview' || (Number(uiProps?.filter?.fields?.length) > 0)) ? <WDFilterPanel
            designer={props.designer}
            uxpContext={props.uxpContext}
            uiProps={uiProps}
            containerRef={containerRef}
            data={contextData || {}}
            onChangeFilters={(data) => {
                setContextData(prev => ({ ...prev, filters: data?.filters || {} }))
            }}
            onClearFilters={() => {
                setContextData(prev => ({ ...prev, filters: {} }))
            }}
            onOpenPanel={() => {
                if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
                    setDisableDrop(true)
                }
            }}
            onClosePanel={() => { setDisableDrop(false) }}
        /> : null}
    >


        <div className="body" style={{ backgroundColor: backgroundColor }} >
            <FieldContainer
                designer={props.designer}
                uxpContext={props.uxpContext}
                contextData={contextData}
                onChangeData={setContextData}
                uiProps={uiProps}
                disabled={disableDrop}
            />
        </div>

    </WidgetWrapperWithSidebar>)
};

registerCardTemplate({
    id: 'empty-widget',
    name: 'Empty Widget',
    description: 'An empty widget to add items to. This lets you start from scratch and add create custom data entry and presentation forms and widgets.',
    template: XPR,
    canDragDropFields: true,
    icon: ['fas', 'credit-card-blank'],
    complexity: 'advanced',
    autoHieght: true
});